export const MESSAGE_ERROR = 'Przepraszamy, coś poszło nie tak...';
